import { useQuery } from '@tanstack/vue-query';
import { defineStore } from 'pinia';
import { apiClient, Product } from '../api';

export const useProductsStore = defineStore('products', () => {
    const {
        data,
        isFetching: dataFetching,
        isError: dataError,
    } = useQuery({
        queryKey: ['products'],
        queryFn: () => apiClient.products.$get([{ key: 'limit', value: '0' }]),
    });

    const products = computed(() => {
        if (!data.value) return {};

        return data.value.reduce(
            (acc, product) => {
                acc[product.reference] = product;
                return acc;
            },
            {} as Record<string, Product>,
        );
    });

    const total = computed(() => data.value?.total ?? 0);
    const isFetching = computed(() => dataFetching.value);
    const isError = computed(() => dataError.value);

    return { products, total, isFetching, isError };
});
